import { render } from "./nav-switch.vue?vue&type=template&id=ee18ac02&scoped=true"
import script from "./nav-switch.vue?vue&type=script&lang=ts"
export * from "./nav-switch.vue?vue&type=script&lang=ts"

import "./nav-switch.vue?vue&type=style&index=0&id=ee18ac02&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ee18ac02"

export default script